export default __webpack_public_path__ + "static/media/truck.0d53c482.svg";